// Module
var code = "<div id=\"V-77D7FBC5-72C7-4F1F-8C09-43975B7CCF84\"> <div data-b-content=\"{Binding decoratorComponent,ViewSelector:getCompactViewForFormBuilderStructureViewDecorators}\"> </div> </div> ";
// Exports
export default code;